<template>
    <div class="global-dashboard-settings" style="flex: 0 0 0">
        <md-dialog :md-active.sync="open" v-on:close="$router.go(-1)" v-on:md-clicked-outside="$router.go(-1)">
            <md-dialog-title>Global Dashboards Iframe</md-dialog-title>
            <div class="horizontal-wrapper" style="margin: 5pt; min-width: 600pt;">
            
                <div style="flex: 4 0 0" class="vertical-wrapper">

                    <md-tabs :md-active-tab="activeTab" :md-dynamic-height="false" v-on:md-changed="(e) => activeTab = e">
                        
                        <md-tab :id="0" md-label="Allgemein">
                            <md-field>
                                <label for="">Name</label>
                                <md-input v-model="name"></md-input>
                            </md-field>

                            <md-field>
                                <label for="">Iframe URL</label>
                                 <md-input v-model="url"></md-input>
                            </md-field>
                        </md-tab>


                        <md-tab :id="1" md-label="JSON Konfiguration">
                            <div class="vertical-wrapper">

                                
                                <md-field>
                                    <label for="">JSON Konfiguration</label>
                                    <md-textarea v-model="iframeData" type="textarea" :rows="10" style="font-size: 10pt; height: 200pt"></md-textarea>
                                </md-field>

                                <div class="horizontal-wrapper">
                                    <md-button v-on:click="downloadAccessToken"></md-button>
                                </div>
                            </div>
                        </md-tab>

                         <md-tab :id="2" md-label="Fertigstellen" md-disabled>
                            <div class="" style="justify-content: center;">
                                <div v-if="resultIcon == 'success'"></div>
                                <div v-if="resultIcon == 'error'"></div>

                                <h2 style="text-align: center;">{{ resultTitle }}</h2>
                                <div style="text-align: center;">{{ result }}</div>

                                <div style="display: flex; justify-content: center; margin: 10pt 0;">

                                    <md-button v-on:click="downloadAccessToken">Copy Access Token</md-button>
                                </div>
                                

                                <div class="horizontal-wrapper">
                                    <md-button v-on:click="downloadAccessToken"></md-button>
                                </div>
                            </div>
                        </md-tab>

                    </md-tabs>
                    
                </div>
            </div>
            <md-dialog-actions>
                <md-button class="md-primary" v-on:click="$router.go(-1)">Schließen</md-button>
                <md-button class="md-primary" v-if="activeTab == 0" v-on:click="activeTab = activeTab + 1">Weiter</md-button>

                <md-button class="md-primary" v-if="activeTab == 1" v-on:click="saveDashboard">Speichern</md-button>
                <md-button class="md-primary" v-if="activeTab == 2" v-on:click="openIframeDashboard">Fertigstellen</md-button>

            </md-dialog-actions>
        </md-dialog>

         <md-snackbar :md-duration="2000" :md-active.sync="showSnackbar" md-persistent>
            <span>Copied to Clipboard!</span>
            <md-button class="md-primary" @click="showSnackbar = false">Close</md-button>
        </md-snackbar>
    </div>
</template>
<script>
import { mapState } from "vuex";

export default {
    name: 'global-dashboard-settings-view',
    props: {id: [String, Number]},
    computed:{
        token() {
            return this.$store.getters.token
        },
        globalDashboards(){
            return this.$store.getters.getGlobalDashboards
        },

       
        ...mapState(['globalView']),

        name:{
            set(value){
                this.$store.commit('globalView/set-iframe-name', value)
            },
            get(){
                return this.$store.getters['globalView/getIframeName']
            }
        },
        url:{
            set(value){
                this.$store.commit('globalView/set-iframe-url', value)
            },
            get(){
                return this.$store.getters['globalView/getIframeURL']
            }
        },
        iframeData:{
            set(value){
                this.$store.commit('globalView/set-iframe-data', value)
            },
            get(){
                return this.$store.getters['globalView/getIframeData']
            }
        },
        globalDashboardIframeAccessToken(){
            return this.$store.getters['globalView/getIframeAccessToken']

        },
    },
    watch:{
       
    },
    methods:{

        saveDashboard: async function(){
            try{
                await this.$store.dispatch('globalView/edit-global-dashboard-details-iframe', this.id)


                this.resultTitle = 'Erfolgreich'
                this.result = 'Iframe Dashboard wurde erfolgreich gespeichert'
                this.resultIcon = 'success'


                
            }catch(e){

                this.resultTitle = 'Fehler'
                this.result =`Fehler: ${e}`
                this.resultIcon = 'error'
            }
            this.activeTab = 2


        },
        openIframeDashboard(){
                this.$router.push({name: 'main-global-dashboard', params: {id: this.id}})

        }, 
        async downloadAccessToken(){
            const copyText = this.globalDashboardIframeAccessToken;


            try {
                await navigator.clipboard.writeText(copyText);
                this.showSnackbar = true
            } catch (err) {
                console.error('Failed to copy text: ', err);
            }

            this.showSnackbar = true
        }
        
      

    },
    beforeRouteEnter(from, to, next){
        next(vm => {
            vm.open = true

           
            //const IDh_global_db = parseInt(to.params.id | vm.id)
            //console.log(IDh_global_db);
            

            // 
        })  
    },
    sockets:{
      
     
    },
    data(){
        return{
            open: false,
            activeGlobalDashboard: -1,
            lastDashboardId: -1,

            users: [],
            searchText: '',
            dashboardType: 'table',

            changesMade: false,


            searchTextGroups: '',
            groups: [],
            activeTab: 0,


            resultTitle: '',
            result: '',
            resultIcon: '',

            showSnackbar: false,
         
        }
    }
}
</script>
<style>
.md-tabs.vertical-wrapper .md-tabs-navigation{
    flex: 0 0 auto;
}
.md-tabs.vertical-wrapper .md-content{
    display: flex;
    flex-direction: column;
}
.global-dashboard-settings .md-tab{
    display: flex;
    flex-direction: column;
    flex: 1 0 0;
    height: 100%;
}
.gd-item{
    background-color: var(--color1);
    padding: 5pt 20pt;
    cursor: pointer;
}
.gd-item.active{
    background-color: var(--color2);
    color: var(--color1);
}
</style>